import PersonFilter, {
  type PersonFilterProps,
} from '~/components/common/filters/PersonFilter'
import { UserSelectFilterScope } from '~/components/common/inputs/UserSelect'

interface MainTeamMemberFilterProps extends Omit<
  PersonFilterProps,
  'filterScope'
> {}

const MainTeamMemberFilter = (props: MainTeamMemberFilterProps) => (
  <PersonFilter filterScope={UserSelectFilterScope.MainStaff} {...props} />
)

export default MainTeamMemberFilter
